import React, { useEffect } from 'react';
import NoindexRedirect from '../shared/NoindexRedirect';

function scrollToHomeSection(hash) {
	const id = (hash || '').replace('#', '');
	if (!id) return;
	setTimeout(() => {
		const el = document.getElementById(id);
		if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}, 120);
}

export function RedirectToPlaces() {
	return <NoindexRedirect path="/destinations" to={{ pathname: '/', hash: '#places' }} />;
}

export function RedirectToPlan() {
	return <NoindexRedirect to={{ pathname: '/', hash: '#plan' }} />;
}

export function RedirectPlanDream() {
	return <NoindexRedirect path="/plan/dream" to={{ pathname: '/', hash: '#plan' }} />;
}

export function RedirectPlanResearch() {
	return <NoindexRedirect path="/plan/research" to={{ pathname: '/', hash: '#places' }} />;
}

export function RedirectPlanChooseDestination() {
	return <NoindexRedirect path="/plan/choose-destination" to={{ pathname: '/', hash: '#places' }} />;
}

export function RedirectToJourney() {
	return <NoindexRedirect path="/journey" to={{ pathname: '/', hash: '#journey' }} />;
}

/** Scroll to #places / #plan / #journey after landing on the one-page home. */
export function HomeHashScroller() {
	useEffect(() => {
		const hash = window.location.hash;
		if (hash) scrollToHomeSection(hash);
	}, []);
	return null;
}

export { scrollToHomeSection };
